import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import BasicValue from "./BasicValue.js";
import FieldName from "./FieldName.js";
import { makeStyles } from "../../util/tss-react/index.js";
const useStyles = makeStyles()({
    field: {
        display: 'flex',
        flexWrap: 'wrap',
    },
});
export default function SimpleField({ name, value, description, prefix, width, formatter, }) {
    const { classes } = useStyles();
    return value != null ? (_jsxs("div", { className: classes.field, children: [_jsx(FieldName, { prefix: prefix, description: description, name: name, width: width }), _jsx(BasicValue, { value: formatter ? formatter(value, name) : value })] })) : null;
}
